import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@wg/wows-react-uikit';
import styles from './Tooltips.scss';
import { GameItemReward } from '~/types';
import {
    PremiumLevelDescription,
    SecondaryShipCompensationInfo,
    FreeFinalRewardDescription
} from '~/Components/Messages/Messages';


export const RulesButtonTooltip = memo(
    () => {
        const { t } = useTranslation();
        return <div className={styles.padding}>{t('Подробные правила события')}</div>;
    },
    () => true,
);


interface ISecondaryShipDisclaimer {
    secondaryShip?: GameItemReward | null,
}
export const SecondaryShipDisclaimer: React.FC<ISecondaryShipDisclaimer> = memo(({ secondaryShip }) => {
    if (!secondaryShip) {
        return null;
    }

    return (
        <>
            <Divider type={'major'} />
            <div className={styles.premiumRow}>
                <SecondaryShipCompensationInfo secondaryShip={secondaryShip} />
            </div>
        </>
    );
});


interface IMainShipDisclaimer {
    isPremium?: boolean,
    isFreeMainReward?: boolean,
    secondaryShip?: GameItemReward | null,
}
export const MainShipDisclaimer: React.FC<IMainShipDisclaimer> = memo(({
    isPremium,
    isFreeMainReward,
    secondaryShip,
}) => {
    if (!isPremium) {
        return null;
    }

    if (isFreeMainReward && secondaryShip) {
        return (
            <>
                <Divider type={'major'} />
                <div className={styles.premiumRow}>
                    <FreeFinalRewardDescription secondaryShip={secondaryShip} />
                </div>
            </>
        );
    }

    return (
        <>
            <Divider type={'major'} />
            <div className={styles.premiumRow}>
                <PremiumLevelDescription />
            </div>
        </>
    );
});
